import React from 'react'
import { EditIcon } from '../../Icon';
import { CircularAvatar } from '../../commons';
import { formatDate } from '../../../utils/commonFunctions';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

interface Props {
  data: any;
  tableHeader: any;
  editEntry?: Function;
  history?: any;
  handleRedirectToViewOpenItem: (jobId: number) => void;
  isViewOpenItemClientPresent?:boolean;
}
class ClientListTableData extends React.Component<Props> {

  handleRedirect = (jobId: number) => {
    this.props.history.push('/open-items-admin/summary/' + jobId)
  }

  handleEdit = (jobId: number) => {
    this.props.history.push('/open-items-admin/edit/' + jobId)
  }

  getStatus = (status: number) => {
    switch (true) {
      case (status === 0):
        return 'Pending';
      case (status === 1):
        return 'Incomplete';
      case (status === 2):
        return 'Approval Pending';
      case (status === 3):
        return 'Complete';
      default: return;
    }
  }

  getStatusClass = (status: number) => {
    switch (status) {
      case 0:
        return 'pending';
      case 1:
        return 'incomplete';
      case 2:
        return 'approval-pending';
      case 3:
        return 'complete';
      default:
        return;
    }
  }

  renderSummaryTooltip = (props: any, data: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        {data}
      </Tooltip>
    )
  }

  render() {
    const {
      data,
      tableHeader,
      isViewOpenItemClientPresent
    } = this.props;

    return data.map((dataItem: any, index: number) => {
      if (dataItem) {
        let finalSummary = dataItem?.summary?.length > 10 ? `${ dataItem?.summary?.slice(0, 10) }...` : dataItem?.summary;
        return (
          <tr key={index}>
            {
              tableHeader.map((item: any, i: number) => {
                if (item.value === 'summary') {
                  return <>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={this.renderSummaryTooltip('', dataItem?.summary)}
                    >
                      <td>{finalSummary}</td>
                    </OverlayTrigger>
                  </>
                } else if (item.value === 'created_date') {
                  return <td style={{ width: '100px' }}>{formatDate(dataItem?.created_date)}</td>
                } else if (item.value === 'job_type') {
                  return <td>
                    {dataItem[item.value]} <br />
                    <span className='due-date-text'>{`(${ dataItem.job_id })`}</span>
                  </td>
                } else if (item.value === 'period_end') {
                  return <td style={{ width: '100px' }}>{formatDate(dataItem?.period_end)}</td>
                } else if (item.value === 'due_date') {
                  return <td style={{ width: '100px' }}>{formatDate(dataItem?.due_date)}</td>
                } else if (item.value === 'responsible_user') {
                  return <td>
                    <div className="d-flex flex-row">
                      <CircularAvatar name={dataItem?.responsible_user} />
                      <p className="ml-1">{dataItem?.responsible_user}</p>
                    </div>
                  </td>
                } else if (item.value === 'first_item_due') {
                  return <td>
                    {dataItem?.first_item_due}
                    {dataItem?.due_items_count > 1 && <span className='ml-1 doc-count-badge'>{`+${ dataItem?.due_items_count - 1 }`}</span>}
                  </td>
                } else if (item.value === 'status_code') {
                  return <td style={{ width: '100px' }}>
                    <p className={`mb-0 text-center status-${ this.getStatusClass(dataItem?.status_code) }`}>{this.getStatus(dataItem?.status_code)}</p>
                  </td>
                } else if (dataItem[item.value]) {
                  return <td> {dataItem[item.value]}</td>
                } else {
                  return <td> --/-- </td>
                }
              })
            }
            <td style={{ width: '80px' }}>
            { isViewOpenItemClientPresent && <span className="d-inline-block pointer"
                onClick={() => this.props.handleRedirectToViewOpenItem(dataItem?.open_item_id)}
              >
                <EditIcon />
              </span>}
            </td>
          </tr>
        )
      }
    })
  }
}

export default ClientListTableData;